import React, { useState } from 'react';
import { Notification } from '../NotificationLoginComponent';
import { sha512 } from 'js-sha512';
import { Link } from 'react-router-dom';
import { CreateUser } from '../../Backend/ApiCalls';
import { guessAgeTypeLabel } from './ageHint';
import './CrearUsuarioComponent.css';

export const CrearUsuarioComponent = (props) => {
  const { user } = props;
  const [errorMessage, setErrorMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const [isErrorNoti, setErrorNoti] = useState(false);

  // En el form, partners y rewards como STRING (CSV). Enviamos [] si está vacío.
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    dni: '',
    partners: '',   // <-- CSV: "Sofia,Maria,Julia"
    telephone: '',
    email: '',
    rewards: '',    // <-- CSV
    birthday: '',
    isTemporary: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const csvToArray = (v) =>
    typeof v === 'string' && v.trim() !== ''
      ? v.split(',').map(s => s.trim()).filter(Boolean)
      : [];

  const generatePassword = (surname, birthday) => {
    const birthDate = new Date(birthday);
    const day = String(birthDate.getDate()).padStart(2, '0');
    const month = String(birthDate.getMonth() + 1).padStart(2, '0');
    const year = String(birthDate.getFullYear()).slice(-2);
    return `${surname.slice(0, 3).toLowerCase()}${day}${month}${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const password = generatePassword(formData.surname, formData.birthday);
    const Noencrto = sha512(password);

    const userData = {
      Username: formData.dni,
      Password: Noencrto,
      Name: formData.name,
      Surname: formData.surname,
      Dni: formData.dni,
      Partners: csvToArray(formData.partners),   // <-- siempre array
      Telephone: formData.telephone ? parseInt(formData.telephone, 10) : null,
      Email: formData.email,
      Rewards: csvToArray(formData.rewards),     // <-- siempre array
      Birthday: formData.birthday,
      UserRank: 0,
      AgeType: formData.isTemporary ? 4 : undefined,
    };

    const { response } = await CreateUser(userData);

    if (!response.ok) {
      setErrorMessage(props.I18n.ErrorMessageCreateUser);
      setErrorNoti(true);
    } else {
      setErrorMessage(props.I18n.SuccessMessageCreateUser);
      setErrorNoti(false);
      setFormData({
        name: '',
        surname: '',
        dni: '',
        partners: '',   // ← volvemos a string vacío
        telephone: '',
        email: '',
        rewards: '',
        birthday: '',
        isTemporary: false,
      });
      setTimeout(() => { window.location.href = '/admin/administracion-usuarios'; }, 3000);
    }
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 5000);
  };

  return (
    <div className="create-user">
      {showNotification && (
        <Notification message={errorMessage} type={isErrorNoti ? "error" : "success"} />
      )}

      <h1 className="titulo-page">Crear Nuevo Usuario</h1>
      <div>
        <Link to="/admin/administracion-usuarios" className="button-default">
          {props.I18n.Return}
        </Link>
      </div>

      <div className="recipient">
        <div className="create-user-container">
          <form className="create-user-form" onSubmit={handleSubmit}>
            <label className="create-user-label">
              {props.I18n.Name}:
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.Surname}:
              <input
                type="text"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
                required
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.DNI}:
              <input
                type="text"
                name="dni"
                value={formData.dni}
                onChange={handleChange}
                required
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.Partners}:
              <input
                type="text"
                name="partners"
                placeholder="Sofia,Maria,Julia"
                value={formData.partners}
                onChange={handleChange}
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.Phone}:
              <input
                type="text"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.Email}:
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.Rewards}:
              <input
                type="text"
                name="rewards"
                placeholder="Descuento1,Descuento2"
                value={formData.rewards}
                onChange={handleChange}
                className="create-user-input"
              />
            </label>

            <label className="create-user-label">
              {props.I18n.Birthdate}:
              <input
                type="date"
                name="birthday"
                value={formData.birthday}
                onChange={handleChange}
                required
                className="create-user-input"
              />
            </label>

            <label className="create-user-checkbox">
              <input
                type="checkbox"
                name="isTemporary"
                checked={formData.isTemporary}
                onChange={handleChange}
              />
              <span>Usuario temporal</span>
            </label>

            {formData.birthday && (
              <div className="age-hint">
                Grupo estimado (corte 15/03): <strong>{formData.isTemporary ? 'Temporal -> 4' : guessAgeTypeLabel(formData.birthday)}</strong>
              </div>
            )}

            <div>
              <button type="submit" className="button-default">
                {props.I18n.CreateUser}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};
